import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Form, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import leaveBalance from '../../assets/images/leave-balance.svg';
import '../../assets/css/dashboard.scss';
import '../../assets/css/customermanagement.scss';
import '../../assets/css/usermanagement.scss';
import '../../assets/css/leaves.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import LeavesTable from './LeavesTable';
import SbCancelBtn, { SbAddBtn } from '../Buttons/Buttons';
import ApplyLeavesModal from './ApplyLeavesModal';
import LeaveBalanceDetails from './LeaveBalanceDetails';
import Download from '../MainSection/Download/Download';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadLeaveData, loadLeavesCountData, loadSingleLeaveData, postUpdateLeaveDatas } from '../../redux/action';
import { ADDED_BY_ID } from '../../Constants';
import * as HeaderAuthentication from '../HeaderAuthentication'
import PendingLeaveDetails from './PendingLeaveDetails';
import ApprovedLeaveDetails from './ApprovedLeaveDetails';
import RejectedLeaveDetails from './RejectedLeaveDetails';
import LeaveDetails from './LeaveDetails';
import LeaveDetailsForUser from './LeaveDetailsForUser';
import moment from 'moment';

const Leaves = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const signInUserId = signInDetails[0]?.UserID;
    const { leaveData } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { leavesCount } = useSelector((state) => state.data);
    const { singleLeaveData = [] } = useSelector((state) => state.data);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [showLeaveBalanceDetails, setShowLeaveBalanceDetails] = useState(false);
    const [showLeaveOverAllDetails, setShowLeaveOverAllDetails] = useState(false);
    const [showPendingLeaveDetails, setShowPendingLeaveDetails] = useState(false);
    const [showApprovedLeaveDetails, setShowApprovedLeaveDetails] = useState(false);
    const [showRejectedLeaveDetails, setShowRejectedLeaveDetails] = useState(false);
    const [activeCard, setActiveCard] = useState(''); // State to track the active card
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [loginAsUser, setLoginAsUser] = useState("");

    const leavesData = () => {
        const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
        const formattedToDate = moment(toDate).format("YYYY-MM-DD");
        dispatch(loadLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, formattedFromDate, formattedToDate));
    }
    useEffect(() => {
        leavesData();
    }, [searchQuery, fromDate, toDate, rowsPerPage, page,]);

    useEffect(() => {
        dispatch(loadLeavesCountData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate));
    }, []);

    const fetchSingleLeaveData = () => {
        if (signInUserId) {
            dispatch(loadSingleLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate, "", signInUserId));
        }
    };

    // Call the function inside useEffect
    useEffect(() => {
        fetchSingleLeaveData();
    }, [rowsPerPage, page + 1, searchQuery, fromDate, toDate, '', signInUserId, dispatch]);

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };
    const [subordinateView, setSubordinateView] = useState(false);

    const fetchSubOrdinatesData = () => {
        if (signInUserId) {
            console.log(signInUserId, 'signInUserId')
            dispatch(loadSingleLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate, "", "", signInUserId));
        }
    };

    // Call API when subordinateView is enabled
    useEffect(() => {
        // if (
        //     signInDetails?.length > 0 &&
        //     signInDetails[0]?.SignInType === "User" &&
        //     signInDetails[0]?.HasSubordinates === "Yes" &&
        //     subordinateView
        // ) {
        //     fetchSubOrdinatesData();
        // }
        if (
            signInDetails?.length > 0 &&
            signInDetails[0]?.SignInType === "User"
        ) {
            if (subordinateView && signInDetails[0]?.HasSubordinates === "Yes") {
                fetchSubOrdinatesData();
            } else {
                fetchSingleLeaveData();
            }
        }
    }, [rowsPerPage, page + 1, searchQuery, fromDate, toDate, '', "", signInUserId, subordinateView, dispatch]);

    const handleCardClick = (cardType) => {
        setActiveCard(cardType);
        if (cardType === 'LeaveBalance') {
            setShowLeaveBalanceDetails(true);
            setShowLeaveOverAllDetails(false);
            setShowPendingLeaveDetails(false);
            setShowApprovedLeaveDetails(false);
            setShowRejectedLeaveDetails(false);
        } else if (cardType === 'OverAll') {
            setShowLeaveOverAllDetails(true);
            setShowLeaveBalanceDetails(false);
            setShowPendingLeaveDetails(false);
            setShowApprovedLeaveDetails(false);
            setShowRejectedLeaveDetails(false);
        } else if (cardType === 'Pending') {
            setShowLeaveOverAllDetails(false);
            setShowLeaveBalanceDetails(false);
            setShowPendingLeaveDetails(true);
            setShowApprovedLeaveDetails(false);
            setShowRejectedLeaveDetails(false);
        } else if (cardType === 'Approved') {
            setShowLeaveOverAllDetails(false);
            setShowLeaveBalanceDetails(false);
            setShowPendingLeaveDetails(false);
            setShowApprovedLeaveDetails(true);
            setShowRejectedLeaveDetails(false);
        } else if (cardType === 'Rejected') {
            setShowLeaveOverAllDetails(false);
            setShowLeaveBalanceDetails(false);
            setShowPendingLeaveDetails(false);
            setShowApprovedLeaveDetails(false);
            setShowRejectedLeaveDetails(true);
        }
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    };

    const handleDateChange = (date, type) => {
        if (type === 'from') {
            setFromDate(date);
        } else if (type === 'to') {
            setToDate(date);
        }
    };

    const navigate = useNavigate();
    const handleAnalyticsClick = () => {
        navigate('/attendanceDashboard')
    }
    const handleBack = () => {
        // navigate(-1);
        if (showLeaveBalanceDetails || showLeaveOverAllDetails) {
            // Reset both details views
            setShowLeaveBalanceDetails(false);
            setShowLeaveOverAllDetails(false);
            // Navigate to the main Leaves & Holidays page
            navigate('/leaves'); // Adjust this path if necessary
        } else {
            navigate(-1); // Go back to the previous page if no detail view is open
        }
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        leavesData();
    }

    const handleStatusChange = (customer, statusLabel, rejectionReason = '') => {
        const statusMap = {
            "Pending": 58,
            "Approved": 59,
            "Rejected": 60,
        };

        const statusID = statusMap[statusLabel] || 58; // Default to "Pending" if no match
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.UserID; // Use UserID for User type
        }

        const todayDate = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD" format
        // console.log("🚀 Updating Status:", { customer, statusLabel, statusID });

        const data = {
            LeaveID: customer.LeaveID,
            StatusID: statusID,
            Message: statusLabel === "Rejected" ? rejectionReason : "", // Only send reason if rejected
            UpdatedByID: CustomerID,
            UpdatedOn: todayDate,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postUpdateLeaveDatas(requestOption, handleCloseModal, leavesData));
        // console.log(data, 'data')
    };

    return (
        <div className="customer-management-container">
            {signInDetails?.length > 0 &&
                // signInDetails[0]?.SignInType === "User" &&
                // signInDetails[0]?.HasSubordinates === "Yes" &&
                (
                    (signInDetails[0]?.SignInType === "User" && signInDetails[0]?.HasSubordinates === "Yes") ||
                    signInDetails[0]?.SignInType !== "User"
                ) &&
                <Main>
                    <div className='components-download-container'>
                        <Download
                            showBackButton={true}
                            moduleName={!showLeaveBalanceDetails ? "Leaves & Holidays" : "Leaves Details"}
                            showDashboardLibraryButton={false}
                            showSaveCustomViewButton={false}
                            showAnalyticsButton={true}
                            showDownloadDropdown={true}
                            onClick={handleAnalyticsClick}
                            onBackClick={handleBack}
                        />
                    </div>
                    <Row className='leaves-cards-container'>
                        <Col
                            md={2}
                            className={`leave-cards  ${activeCard === 'OverAll' ? 'active-card' : ''}`}
                            onClick={() => handleCardClick('OverAll')}
                        >
                            <div className='leave-cards-counts'>
                                <b className='overAll-count'>{leavesCount?.RecordCount}</b>
                                <p className='leave-overall-p-div'>Overall Users</p>
                            </div>
                        </Col>
                        <Col md={2} className={`leave-cards  ${activeCard === 'Pending' ? 'active-card' : ''}`}
                            onClick={() => handleCardClick('Pending')}>
                            <div className='leave-cards-counts'>
                                <b className='pending-leave-count'>{leavesCount?.PendingCount}</b>
                                <p className='leave-pending-p-div'>Pending Leaves</p>
                            </div>
                        </Col>
                        <Col md={2} className={`leave-cards  ${activeCard === 'Approved' ? 'active-card' : ''}`}
                            onClick={() => handleCardClick('Approved')}>
                            <div className='leave-cards-counts'>
                                <b className='approve-leave-count'>{leavesCount?.ApprovedCount}</b>
                                <p className='leave-approved-p-div'>Approved Leaves</p>
                            </div>
                        </Col>
                        <Col md={2} className={`leave-cards  ${activeCard === 'Rejected' ? 'active-card' : ''}`}
                            onClick={() => handleCardClick('Rejected')}>
                            <div className='leave-cards-counts'>
                                <b className='rejected-leave-count'>{leavesCount?.RejectedCount}</b>
                                <p className='leave-rejected-p-div'>Rejected Leaves</p>
                            </div>
                        </Col>
                        <Col
                            md={2}
                            className={`leave-cards ${activeCard === 'LeaveBalance' ? 'active-card' : ''}`}
                            onClick={() => handleCardClick('LeaveBalance')}
                        >
                            <div className='leave-cards-counts'>
                                <b className='leave-balance'>
                                    <img src={leaveBalance} alt="" />
                                </b>
                                <p className='leave-balance-p-div'>Leave Balance</p>
                            </div>
                            {/* <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                            <img src={customerLicenseExperation} alt="" />
                        </div> */}
                        </Col>
                    </Row>
                    <div className='customermanagement-content-container'>

                        {!showLeaveBalanceDetails && !showPendingLeaveDetails && !showApprovedLeaveDetails && !showRejectedLeaveDetails && (
                            <div className="customermanagement-content">
                                <Row className='customermanagement-btns-container'>
                                    <Col md={3} className='customermanagement-backbtn-div'>
                                        <span>Overall User</span>
                                    </Col>
                                    <Col md={9} className='customermanagement-search-filter'>
                                        {signInDetails?.length > 0 &&
                                            signInDetails[0]?.SignInType === "User" &&
                                            signInDetails[0]?.HasSubordinates === "Yes" && (
                                                <Form.Check
                                                    type="switch"
                                                    id="subordinate-toggle"
                                                    label="My Subordinates"
                                                    checked={subordinateView}
                                                    onChange={() => setSubordinateView(!subordinateView)}
                                                    className="ms-3"
                                                />
                                            )}
                                        <Col md={5} className='filters-col'>
                                            <div className='customermanagement-search'>
                                                <Form.Control
                                                    type="search"
                                                    placeholder='Search'
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                />
                                                <img src={searchIcon} alt="Search" onClick={handleSearchClick} />
                                            </div>
                                        </Col>
                                        <Col md={2} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selectsStart
                                                    dropdownMode="select"
                                                    placeholderText='From'
                                                    selected={fromDate}
                                                    onChange={(date) => setFromDate(date)}
                                                    maxDate={new Date()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        <Col md={2} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selectsEnd
                                                    placeholderText='To'
                                                    dropdownMode="select"
                                                    selected={toDate}
                                                    onChange={(date) => setToDate(date)}
                                                    minDate={new Date()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        {/* hide for super admin below add button */}
                                        <SbAddBtn btnName="Apply Leaves" onClickEffect={handleOpenModal} />
                                        <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                    </Col>
                                </Row>
                                <div className='customermanagement-table-div  leave-details-table'>
                                    {!showLeaveOverAllDetails && !showLeaveBalanceDetails && !showApprovedLeaveDetails && !showRejectedLeaveDetails
                                        &&
                                        // signInDetails?.length > 0 &&
                                        // signInDetails[0]?.SignInType === "User" &&
                                        // signInDetails[0]?.HasSubordinates === "Yes" &&
                                        (
                                            (signInDetails[0]?.SignInType === "User" && signInDetails[0]?.HasSubordinates === "Yes") ||
                                            signInDetails[0]?.SignInType !== "User"
                                        ) &&
                                        < LeavesTable
                                            handleOpenModal={handleOpenModal}
                                            handleViewDetails={handleViewDetails}
                                            leaveData={leaveData}
                                            totalDataCount={totalDataCount}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            setPage={setPage}
                                            setRowsPerPage={setRowsPerPage}
                                            handleStatusChange={handleStatusChange}
                                            loading={loading}
                                            singleLeaveData={singleLeaveData}
                                            signInDetails={signInDetails}
                                        />
                                    }
                                </div>
                            </div>
                        )}
                        <div>
                            {showLeaveBalanceDetails && !showLeaveOverAllDetails && !showPendingLeaveDetails && !showApprovedLeaveDetails && !showRejectedLeaveDetails &&
                                < LeaveBalanceDetails loading={loading} setLoading={setLoading} />
                            }
                        </div>
                        <div>
                            {showPendingLeaveDetails && !showLeaveBalanceDetails && !showLeaveOverAllDetails && !showApprovedLeaveDetails && !showRejectedLeaveDetails &&
                                <PendingLeaveDetails loading={loading} setLoading={setLoading} />
                            }
                        </div>
                        <div>
                            {showApprovedLeaveDetails && !showPendingLeaveDetails && !showLeaveBalanceDetails && !showLeaveOverAllDetails && !showRejectedLeaveDetails &&
                                <ApprovedLeaveDetails loading={loading} setLoading={setLoading} />
                            }
                        </div>
                        <div>
                            {showRejectedLeaveDetails && !showApprovedLeaveDetails && !showPendingLeaveDetails && !showLeaveBalanceDetails && !showLeaveOverAllDetails &&
                                <RejectedLeaveDetails loading={loading} setLoading={setLoading} />
                            }
                        </div>

                        {showLeaveOverAllDetails && !showLeaveBalanceDetails && !showPendingLeaveDetails && showApprovedLeaveDetails && !showRejectedLeaveDetails &&
                            // signInDetails?.length > 0 &&
                            // signInDetails[0]?.SignInType === "User" &&
                            // signInDetails[0]?.HasSubordinates === "Yes" &&
                            (
                                (signInDetails[0]?.SignInType === "User" && signInDetails[0]?.HasSubordinates === "Yes") ||
                                signInDetails[0]?.SignInType !== "User"
                            ) &&
                            <LeavesTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                leaveData={leaveData}
                                totalDataCount={totalDataCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                handleStatusChange={handleStatusChange}
                                loading={loading}
                                singleLeaveData={singleLeaveData}
                                signInDetails={signInDetails}
                            />}
                    </div>
                </Main>
            }
            {isModalOpen && <ApplyLeavesModal open={isModalOpen} handleCloseModal={handleCloseModal} leavesData={leavesData} />}
            <div>
                {signInDetails[0]?.SignInType === "User" && signInDetails[0]?.HasSubordinates === "No" &&
                    < LeaveDetailsForUser signInUserId={signInDetails[0]?.UserID} />
                }
            </div>
        </div>
    );
};

export default Leaves;
